import ProfileFormContainer from '../ProfileFormContainer';

const Profile = () => {
  return (
    <div className="bg-card px-12 py-8 rounded-lg !w-full">
      <ProfileFormContainer />
    </div>
  );
};

export default Profile;
